import React from "react";
import {WithTranslation, withTranslation} from "react-i18next";

/**
 *
 * @author Alizée Grand
 * @version 1.0
 * @creation 18/05/2022
 * @last_update 18/05/2022
 **/
class MissingField extends React.Component<WithTranslation> {

    render() {

        return (

            <p className="errorMsg">
                {this.props.t("steps.validation.missing-field")}
            </p>

        );

    };

}

export default withTranslation()(MissingField);
